import type React from 'react';
import { useEffect } from 'react';

import { FuturesProgressStep, type InstitutionFuturesProgressStep, useProgress } from '@/context/progress';
import BaseLayout from '@/layouts/base';

export type FuturesClientCategorisationLayoutProps = React.ComponentPropsWithoutRef<typeof BaseLayout> & {
  progress?: number;
  step?:
    | Extract<FuturesProgressStep, typeof FuturesProgressStep.CLIENT_CATEGORISATION>
    | Extract<InstitutionFuturesProgressStep, typeof InstitutionFuturesProgressStep.CLIENT_CATEGORISATION>;
};

const FuturesClientCategorisationLayout = ({ progress, step = FuturesProgressStep.CLIENT_CATEGORISATION, ...props }: FuturesClientCategorisationLayoutProps) => {
  const { setCurrentStep } = useProgress();

  useEffect(() => {
    return setCurrentStep(step, progress);
  }, [progress, setCurrentStep, step]);

  return <BaseLayout {...props} />;
};
FuturesClientCategorisationLayout.displayName = 'FuturesClientCategorisationLayout';

export default FuturesClientCategorisationLayout;
